import React from "react";
import { Shield,} from "lucide-react";
import { PrivacyPolicyPageSEO } from "../components/SEO";
import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  return (
    <div className="privacy-page">
      <PrivacyPolicyPageSEO />
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container hero-content">
          <div className="hero-icon-wrapper">
            <Shield className="hero-icon" />
          </div>
          <h1 className="page-title">Privacy Policy</h1>
          
          <p className="last-updated">Last Updated: January 2026</p>
        </div>
      </section>

      {/* Main Content */}
      <main className="container privacy-content">
        <div className="content-wrapper">
          {/* Introduction */}
          <section className="policy-section">
            <div className="section-icon">
              
            </div>
            <h2>Introduction</h2>
            <p>
              Migarda Investments CC, trading as Telkom ("we," "us," or "our"), is committed to protecting 
              your privacy and ensuring the security of your personal information. This Privacy Policy explains 
              how we collect, use, disclose, and safeguard your information when you visit our stores, use our 
              services, or interact with us online.
            </p>
            <p>
              As an authorized Telkom franchisee, we comply with the Protection of Personal Information Act 
              (POPIA) and other applicable South African privacy laws.
            </p>
          </section>

          {/* Information We Collect */}
          <section className="policy-section">
            <div className="section-icon">
              
            </div>
            <h2>Information We Collect</h2>
            
            <h3>Personal Information</h3>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li><strong>Identity Information:</strong> Name, surname, ID number, date of birth</li>
              <li><strong>Contact Information:</strong> Phone number, email address, physical address</li>
              <li><strong>Financial Information:</strong> Banking details for contract agreements</li>
              <li><strong>Transaction Information:</strong> Purchase history, service subscriptions</li>
              <li><strong>Technical Information:</strong> IP address, browser type, device information when using our website</li>
            </ul>

            <h3>How We Collect Information</h3>
            <ul>
              <li>Directly from you when you purchase products or services</li>
              <li>When you complete application forms or contracts</li>
              <li>Through our website and online interactions</li>
              <li>Via customer service interactions</li>
              <li>From third-party service providers with your consent</li>
            </ul>
          </section>

          {/* How We Use Your Information */}
          <section className="policy-section">
            <div className="section-icon">
              
            </div>
            <h2>How We Use Your Information</h2>
            <p>We use your personal information for the following purposes:</p>
            <ul>
              <li><strong>Service Delivery:</strong> To provide telecommunications products and services</li>
              <li><strong>Contract Management:</strong> To process and manage your service contracts</li>
              <li><strong>Customer Support:</strong> To respond to your inquiries and provide assistance</li>
              <li><strong>Legal Compliance:</strong> To comply with legal obligations and regulations</li>
              <li><strong>Fraud Prevention:</strong> To protect against fraudulent activities</li>
              <li><strong>Business Operations:</strong> To improve our services and customer experience</li>
            </ul>
          </section>

          {/* Information Sharing */}
          <section className="policy-section">
            <h2>Information Sharing and Disclosure</h2>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Telkom SA SOC Ltd:</strong> As required for service provisioning and support</li>
              <li><strong>Service Providers:</strong> Third parties who assist us in delivering services</li>
              <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
              <li><strong>Credit Bureaus:</strong> For credit checks and fraud prevention</li>
            </ul>
            <p>
              We do not sell, rent, or trade your personal information to third parties for marketing purposes 
              without your explicit consent.
            </p>
          </section>

          {/* Data Security */}
          <section className="policy-section">
            <div className="section-icon">
            
            </div>
            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information 
              against unauthorized access, loss, destruction, or alteration. These measures include:
            </p>
            <ul>
              <li>Secure storage systems and encrypted databases</li>
              <li>Access controls and authentication procedures</li>
              <li>Regular security assessments and updates</li>
              <li>Staff training on data protection and privacy</li>
              <li>Secure disposal of personal information when no longer needed</li>
            </ul>
          </section>
        
        
          {/* Data Retention */}
          <section className="policy-section">
            <h2>Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill the purposes for which 
              it was collected, including:
            </p>
            <ul>
              <li>For the duration of your service contract</li>
              <li>To comply with legal and regulatory requirements</li>
              <li>To resolve disputes and enforce our agreements</li>
              <li>For legitimate business purposes</li>
            </ul>
            <p>
              Once personal information is no longer needed, we will securely delete or anonymize it.
            </p>
          </section>

          {/* Contact Section */}
          <section className="policy-section contact-section">
            <div className="section-icon">
              
            </div>
            <h2>Contact Us</h2>
            <p>
              If you have any questions, concerns, or requests regarding this Privacy Policy or how we handle 
              your personal information, please contact us:
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <strong>Company:</strong> Migarda Investments CC
              </div>
              <div className="contact-item">
                <strong>Email:</strong> <a href="mailto:info@migarda.co.za">info@migarda.co.za</a>
              </div>
              <div className="contact-item">
                <strong>Phone:</strong> <a href="tel:0614247446">061 424 7446</a>
              </div>
            </div>
          </section>

          
        </div>
      </main>
    </div>
  );
}